import { useEffect, useState } from 'react';
import { Pressable, View } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';
import { Icon } from '@/ui/icon';

import { ChevronDown } from '../icons/chevron-down';
import { ChevronUp } from '../icons/chevron-up';

interface AccordionProps {
  title: string;
  children: React.ReactNode;
  collapsed?: boolean;
  onToggle?: (collapsed: boolean) => void;
}

export default function Accordion({
  title,
  children,
  collapsed = false,
  onToggle,
}: AccordionProps) {
  const { theme } = useStyles();
  const [isCollapsed, setIsCollapsed] = useState(collapsed);

  useEffect(() => {
    setIsCollapsed(collapsed);
  }, [collapsed]);

  return (
    <View>
      <View
        style={{
          paddingTop: 8,
          paddingBottom: 8,
          borderBottomWidth: 1,
          borderBottomColor: theme.colors.card.default.borderColor,
        }}
      >
        <Pressable
          onPress={() => {
            setIsCollapsed((prev) => !prev);
            onToggle?.(!isCollapsed);
          }}
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <Icon
            type="naked"
            icon={isCollapsed ? <ChevronUp /> : <ChevronDown />}
            fillColor={theme.colors.icon.color}
            width={12}
            height={12}
            style={{ width: 36, height: 36 }}
          />

          <Text type="title2">{title}</Text>
        </Pressable>
      </View>

      {!isCollapsed ? <View style={{ paddingTop: 16 }}>{children}</View> : null}
    </View>
  );
}
